import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

// Services
import CandidateService from "../../../services/CandidateService";

const CandidateContributedWeeks = () => {
    const [contributions, setContributions] = useState([]);
    const [candidate, setCandidate] = useState(null);
    const [contributedWeek, setContributedWeek] = useState(null);
    const [statusLabel, setStatusLabel] = useState(""); 
    const history = useHistory();
    const id = useSelector(state => state.candidate);
    const [isLoading, setIsLoading] = useState(false);
    const [loadingHistorical , setlIsHistorical] = useState(true);

    useEffect(() => {
        const getCandidate = async () => {
            try {
                const response = await CandidateService.getCandidate(id);
                const cand = response.data.response[0];

                setCandidate(cand);
                const contribResponse = await CandidateService.getContributedWeek(cand.nss, cand.curp);
                const ocrData = contribResponse.data.response[0];
                setContributedWeek(ocrData);

                if (ocrData?.empleos?.length > 0) {
                    const transformed = ocrData.empleos.map(emp => ({
                        Patron: emp.patron,
                        Registro_patronal: emp.registroPatronal,
                        Entidad_federativa: emp.entidadFederativa,
                        Fecha_alta: emp.fechaAlta.split('T')[0],
                        Fecha_baja: emp.fechaBaja.split('T')[0],
                        Salario_Base: `$${emp.salarioBase.toFixed(2)}`
                    }));
                    setlIsHistorical(false);
                    setContributions(transformed);
                    setStatusLabel("");
                } else {
                    console.log("Empleos no encontrados en los datos OCR.");
                }
            } catch (error) {
                console.error("Error loading candidate or contributions:", error);
            }
        };

        getCandidate();
    }, [id]);
    

    const onClickViewDashboard = () => {
        history.push("/dashboard/candidatos");
    };

    const handleClickHistorical = async () => {
    if (!candidate) return;

    setIsLoading(true);
    setStatusLabel("Procesando...");

    try {
        const response = await CandidateService.postHistorical(candidate.nss, candidate.curp);

        if (response.statusCode === 200 && response.data) {
            if (contributedWeek !== null && typeof contributedWeek !== 'undefined') {
                const historicalData = response.data?.response?.[0];
                if (historicalData) {
                    setContributedWeek(historicalData);
                    setlIsHistorical(false);
                }
            } else {
                setStatusLabel("Semana no encontrada");
            }
            } else {
                setStatusLabel("Procesando tus semanas cotizadas. Vuelve más tarde para revisar.");
            }

        } catch (error) {
            if (error.response?.status === 404) {
                setStatusLabel("Ruta no encontrada en el servicio.");
            } else {
                console.error("Error inesperado:", error);
                setStatusLabel("Ocurrió un error al consultar el histórico.");
            }
        } finally {
            setIsLoading(false);
            console.log("Consulta finalizada para:", candidate.curp);
        }
    };

    const handleClickReport = async () => {
        if (!contributedWeek?.ocr_Id) return;

        try {
            setIsLoading(true);
            setStatusLabel("Descargando...");

            const response = await CandidateService.getContributedWeekReport(contributedWeek.ocr_Id);
            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Reporte_Semanas_Cotizadas_${contributedWeek.nss}.pdf`);
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error al descargar el reporte:", error);
        } finally {
            setIsLoading(false);
            setStatusLabel("");
        }
    };

    return (
        <>
            {isLoading && (
                <div className="overlay-loading">
                    <div className="spinner" />
                </div>
            )}
            <div className={"container"}>
                <div className={"content candidate"}>
                    <div className={"top-section"}>
                        <div className={"candidate-header"}>
                            <div className={"company-name"}>
                                <label className={"company-name-title"}>Estatus</label>
                                <label className={"company-name-value"}>{contributedWeek?.estatus ?? "Proceso Inicial"}</label>
                            </div>
                        </div>
                    </div>

                    <div className={"main-section contributed shadow"}>
                        <div className={"candidate-contributed-weeks"}>
                            <div className={"candidate-section-item"}>
                                <label className={"property"}>Nombre(s) del candidato(a)</label>
                                <label className={"value"}>{candidate?.name} {candidate?.lastname}</label>
                            </div>
                            <div className={"candidate-section-item"}>
                                <label className={"property"}>CURP</label>
                                <label className={"value"}>{candidate?.curp}</label>
                            </div>
                            <div className={"candidate-section-item"}>
                                <label className={"property"}>NSS</label>
                                <label className={"value"}>{candidate?.nss}</label>
                            </div>
                            <div className={"candidate-section-item"}>
                                <label className={"property"}>Semanas cotizadas</label>
                                <label className={"value"}>{contributedWeek?.semanasCotizadas ?? "0"}</label>
                            </div>
                            <div className={"candidate-section-item"}>
                                <label className={"property"}>Fecha de solicitud</label>
                                <label className={"value"}>  
                                    {contributedWeek?.fechaEmision 
                                        ? new Date(contributedWeek.fechaEmision).toLocaleDateString('es-MX') 
                                        : 'N/A'}
                                </label>
                            </div>
                            <div className={"candidate-section-item"}>
                                <label className={"property"}>UUID</label>
                                <label className={"value"}>{contributedWeek?.uuid ?? "N/A" }</label>
                            </div>
                        </div>

                        {/* Tabla de contribuciones */}
                        <div className="table candidates" style={{ marginTop: "210px" }}>
                            <div className="table-row table-row-header">
                                <label className="table-cell-header">Patrón</label>
                                <label className="table-cell-header">Registro patronal</label>
                                <label className="table-cell-header">Entidad federativa</label>
                                <label className="table-cell-header">Fecha alta</label>
                                <label className="table-cell-header">Fecha baja</label>
                                <label className="table-cell-header">Salario base</label>
                            </div>
                            {contributions.map((item, index) => (
                            <div className="table-row" key={index}>
                                <div className="table-cell">{item.Patron}</div>
                                <div className="table-cell">{item.Registro_patronal}</div>
                                <div className="table-cell">{item.Entidad_federativa}</div>
                                <div className="table-cell">{item.Fecha_alta}</div>
                                <div className="table-cell">{item.Fecha_baja}</div>
                                <div className="table-cell">{item.Salario_Base}</div>
                            </div>
                            ))}
                        </div>

                       <div className={"candidate-view-container"}>
                            <button
                                className={"candidate-view-accept"}
                                onClick={onClickViewDashboard}
                                disabled={isLoading}>
                               {"Regresar"} 
                            </button>

                            <button
                                className={"candidate-view-accept"}
                                onClick={handleClickHistorical}
                                disabled={isLoading || !loadingHistorical}>
                                  {"Consultar"}
                            </button>

                            <button
                                className={"candidate-view-accept"}
                                onClick={handleClickReport}
                                disabled={isLoading || loadingHistorical}>
                                  {"Reporte"}
                            </button>


                            <div className={"candidate-section-item"} style={{ padding: "15px" }}>
                                    {isLoading ? (
                                        <span>
                                            <span className="spinner " />
                                            <label style={{ whiteSpace: "pre-line" }} className={"value"}>{statusLabel}</label>
                                        </span>
                                    ) : (
                                        statusLabel
                                    )}

                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default CandidateContributedWeeks;
